<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <router-link class="section" to="/contracts">
                Contratos
              </router-link>
              <i class="right chevron icon divider"></i>
              <router-link
                class="section"
                :to="`/contracts/${$route.params.contract_id}`"
              >
                {{ $route.params.contract_id }}
              </router-link>
              <i class="right chevron icon divider"></i>
              <router-link
                class="section"
                :to="`/contracts/${$route.params.contract_id}/procedure_authorizations`"
              >
                <div class="neutral">Autorizações</div>
              </router-link>
              <i class="right chevron icon divider"></i>
              <div class="active section">{{ sectionName }}</div>
            </Breadcrumb>
          </div>
          <div v-show="persisted" class="eight wide right aligned column">
            <div class="actions">
              <router-link
                class="section"
                :to="`/contracts/${$route.params.contract_id}/invoices/new`"
              >
                <i class="plus icon"></i>
                Nova Autorização
              </router-link>
              <a @click.prevent="openHistory">
                <i class="history icon"></i>Histórico
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <HistoryModal
        ref="history"
        resource="ProcedureAuthorization"
        :item_id="procedureAuthorization.id"
      />
      <form class="ui small form" v-autocomplete-off ref="form">
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="ten wide column">
              <div class="fields">
                <div class="required ten wide field">
                  <label for="procedure-authorization-description">
                    Procedimento
                  </label>
                  <select
                    id="procedure-authorization-description"
                    class="ui fluid search dropdown"
                    v-model="form.description"
                    autofocus
                  >
                    <option
                      v-for="(procedure, index) in proceduresOptions"
                      :key="index"
                      :value="procedure"
                    >
                      {{ procedure }}
                    </option>
                  </select>
                </div>
                <div class="four required wide field">
                  <label for="procedure-authorization-value">Valor</label>
                  <money
                    autofocus
                    v-model="form.value"
                    @keyup.native.enter="add"
                  ></money>
                </div>
                <div class="two wide field">
                  <label style="visibility: hidden">hide</label>
                  <button
                    type="button"
                    name="add"
                    @click.prevent="add"
                    :class="['ui icon', { disabled: false }, 'button']"
                  >
                    <i class="plus icon"></i>
                  </button>
                </div>
              </div>

              <div class="ui segment">
                <table class="ui very basic table">
                  <thead>
                    <th>Procedimento</th>
                    <th>Valor</th>
                    <th></th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(
                        procedure, index
                      ) in procedureAuthorization.procedures"
                      :key="index"
                    >
                      <td class="bold">{{ procedure.description }}</td>
                      <td>{{ procedure.value | money }}</td>
                      <td>
                        <button
                          type="button"
                          name="add"
                          title="Remover procedimento"
                          @click.prevent="
                            procedureAuthorization.procedures.splice(index, 1)
                          "
                          class="ui icon basic button"
                        >
                          <i class="trash icon"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th style="text-align: right">Total:</th>
                      <th>
                        <b>{{ total | money }}</b>
                      </th>
                      <th></th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="save"
                  type="button"
                  name="save"
                  class="ui submit blue button"
                >
                  <i class="save icon"></i>Salvar Autorização
                </button>
                <a v-show="persisted" class="delete" @click.prevent="remove">
                  <i class="trash icon"></i>Remover Autorização
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import HistoryModal from '@/components/history_modal';
const DEFAULT_PROCEDURES_OPTIONS = ['Exames Laboratoriais'];

export default {
  components: { Breadcrumb, PageLayout, HistoryModal },

  watch: {
    $route() {
      if (_.isEmpty(this.$route.params.id)) {
        this.clearForm();
      }
    }
  },

  data() {
    return {
      proceduresOptions: DEFAULT_PROCEDURES_OPTIONS,
      loading: false,
      procedureAuthorization: {
        id: null,
        procedures: []
      },
      form: {
        value: 0,
        description: DEFAULT_PROCEDURES_OPTIONS[0]
      }
    };
  },

  computed: {
    persisted() {
      return this.procedureAuthorization.id != null;
    },

    sectionName() {
      return this.persisted
        ? `Editar Autorização - ${this.procedureAuthorization.id}`
        : 'Nova Autorização';
    },

    total() {
      let sum = 0;
      for (var i = 0; i < this.procedureAuthorization.procedures.length; i++) {
        sum += this.procedureAuthorization.procedures[i].value;
      }

      return sum;
    }
  },

  mounted() {
    this.init();
  },

  methods: {
    _clearForm() {
      this.form.value = 0;
      this.form.description = DEFAULT_PROCEDURES_OPTIONS[0];
    },

    _isValid() {
      if (this.form.description == null || this.form.description == '') {
        this.$toast.show('Adicione uma descrição', 'error');
        return false;
      }

      if (this.form.value <= 0) {
        this.$toast.show('Valor deve ser maior que R$ 0,00', 'error');
        return false;
      }

      return true;
    },

    add() {
      if (this._isValid()) {
        const payload = Object.assign({}, this.form);
        this.procedureAuthorization.procedures.push(payload);
        this._clearForm();
      }
    },
    clearForm() {
      this.form = {
        description: null,
        value: 0
      };
    },

    init() {
      if (this.$route.params.id) {
        this.fetch(this.$route.params.id);
      }

      $('#procedure-authorization-description').dropdown({
        allowAdditions: true
      });
    },

    openHistory() {
      this.$refs.history.open();
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    _setErrors(errors) {
      this.errors = _.clone(errors || {});
      setTimeout(() => {
        $('.error.field').popup();
      }, 100);
    },

    save() {
      this.loading = true;

      const payload = {
        contract_id: this.$route.params.contract_id,
        id: this.procedureAuthorization.id,
        procedures: Object.assign([], this.procedureAuthorization.procedures)
      };

      Api.procedureAuthorizations
        .save(payload)
        .then(async response => {
          this.$toast.show('Autorização salva com sucesso', 'success');
          this.procedureAuthorization = response.data.procedure_authorization;
          // this._parseForm(response.data.invoice);
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.errors) {
              for (const value of Object.values(error.response.data.errors)) {
                this.$toast.show(value, 'error');
              }
            } else {
              this.$toast.show('Erro ao salvar autorização', 'error');
            }
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    remove() {
      const removeIt = confirm('Remover autorização?');
      if (removeIt) {
        this.loading = true;
        Api.procedureAuthorizations
          .destroy(this.procedureAuthorization.id)
          .then(async () => {
            this.$toast.show('Autorização removida com sucesso', 'success');
            this.$router.push({
              name: 'contract_procedure_authorizations',
              params: {
                contract_id: this.$route.params.contract_id
              }
            });
          })
          .catch(error => {
            if (error.response) {
              this.$toast.show('Erro ao remover autorização', 'error');
              this._setErrors(error.response.data.errors);
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      }
    },

    fetch(id) {
      this.loading = true;
      Api.procedureAuthorizations
        .fetch(id)
        .then(async response => {
          this.procedureAuthorization = response.data.procedure_authorization;
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao buscar autorização', 'error');
            this.$router.go(-1);
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    }
  }
};
</script>
